export default __webpack_public_path__ + "675d1698d31ddd95f5e922ca5a6fa393.png";